import { RSAA } from 'redux-api-middleware';
import fetch from 'isomorphic-fetch';
import api from '../../api';
import { CLOSE_ADDED_TO_CART } from './addedToCart';
import { CREATE_ORDER_NOT_AVAILABLE } from './checkout';
import { isValidCoupon } from './checkout';

// ------------------------------------
// Constants
// ------------------------------------

const CREATE_REQUEST = 'farmakom/cart/CREATE_REQUEST';
const CREATE_SUCCESS = 'farmakom/cart/CREATE_SUCCESS';
const CREATE_FAILURE = 'farmakom/cart/CREATE_FAILURE';

const LOAD_REQUEST = 'farmakom/cart/LOAD_REQUEST';
export const LOAD_SUCCESS = 'farmakom/cart/LOAD_SUCCESS';
const LOAD_FAILURE = 'farmakom/cart/LOAD_FAILURE';

const ADD_TO_CART_REQUEST = 'farmakom/cart/ADD_TO_CART_REQUEST';
export const ADD_TO_CART_SUCCESS = 'farmakom/cart/ADD_TO_CART_SUCCESS';
const ADD_TO_CART_FAILURE = 'farmakom/cart/ADD_TO_CART_FAILURE';

const REMOVE_FROM_CART_REQUEST = 'farmakom/cart/REMOVE_FROM_CART_REQUEST';
const REMOVE_FROM_CART_SUCCESS = 'farmakom/cart/REMOVE_FROM_CART_SUCCESS';
const REMOVE_FROM_CART_FAILURE = 'farmakom/cart/REMOVE_FROM_CART_FAILURE';

const UPDATE_CART_QUANTITY_REQUEST =
  'farmakom/cart/UPDATE_CART_QUANTITY_REQUEST';
const UPDATE_CART_QUANTITY_SUCCESS =
  'farmakom/cart/UPDATE_CART_QUANTITY_SUCCESS';
const UPDATE_CART_QUANTITY_FAILURE =
  'farmakom/cart/UPDATE_CART_QUANTITY_FAILURE';

const EMPTY_CART = 'farmakom/cart/EMPTY_CART';

// ------------------------------------
// Actions
// ------------------------------------

function createCart() {
  // THUNK
  return (dispatch, getState) => {
    const { endpoint, method, headers, body } = api.createCart();

    const storeid = getState().store.data.storeId;

    const headersWithStoreId = {
      ...headers,
      storeid,
    };

    dispatch({
      type: CREATE_REQUEST,
    });

    fetch(endpoint, { method, headers: headersWithStoreId, body })
      .then(response => {
        if (response.ok) {
          response.json().then(data => {
            dispatch({
              type: CREATE_SUCCESS,
              payload: data,
            });
            // SAVE TO LOCALSTORAGE
            localStorage.setItem('cartId', data.cartId);
            localStorage.setItem('cartToken', data.authToken);
          });
        } else {
          dispatch({
            type: CREATE_FAILURE,
            payload: response.statusText,
          });
        }
      })
      .catch(error => {
        dispatch({
          type: CREATE_FAILURE,
          payload: error,
        });
      });
  };
}

export function loadCart() {
  const cartId = localStorage.getItem('cartId');

  if (!cartId) {
    // Non ho un cartId nel localStorage
    // ==> Devo chiedere al server un cartId
    return createCart();
  } else {
    // Ho un cartId, provo a chiedere il relativo carrello
    // Se ok, ottengo il carrello,
    // altrimenti, per qualche motivo, il cartId non c'è sul server
    // (ad es. mi connetto al server di prod dopo essermi connesso a quello dev)
    // ==> Resetto quindi il localStorage e chiedo un nuovo cartId

    // THUNK
    return (dispatch, getState) => {
      const { endpoint, method, headers, body } = api.getCart(cartId);
      const storeid = getState().store.data.storeId;

      const headersWithStoreId = {
        ...headers,
        storeid,
      };

      dispatch({
        type: LOAD_REQUEST,
      });

      fetch(endpoint, { method, headers: headersWithStoreId, body })
        .then(response => {
          if (response.ok) {
            response.json().then(data => {
              dispatch({
                type: LOAD_SUCCESS,
                payload: {
                  ...data,
                  products: data.products,
                },
              });
            });
          } else {
            if (response.status === 404 || response.status === 401) {
              // DELETE CARTID FROM LOCALSTORAGE
              localStorage.removeItem('cartId');
              localStorage.removeItem('cartToken');

              // Request new cartId
              return createCart();
            }

            dispatch({
              type: LOAD_FAILURE,
              payload: response.statusText,
            });
          }
        })
        .catch(error => {
          dispatch({
            type: LOAD_FAILURE,
            payload: error,
          });
        });
    };
  }
}

// THUNK
export function addToCart(product, quantity) {
  const cartId = localStorage.getItem('cartId');

  if (!cartId) {
    // Non ho un cartId nel localStorage
    // ==> Devo chiedere al server un cartId
    return createCart();
  }

  const { endpoint, method, headers, body } = api.addProductToCart(
    cartId,
    product.id,
    quantity
  );

  return (dispatch, getState) => {
    const { store } = getState();

    const storeid = store.data.storeId;

    const headersWithStoreId = {
      ...headers,
      storeid,
    };

    const maxAddable = getMaxAddable(getState(), product, quantity);

    // Forzo la quantità a non superare la massima possibile
    if (quantity > maxAddable) {
      quantity = maxAddable;
    }

    dispatch({
      type: ADD_TO_CART_REQUEST,
      payload: { cartId, product, quantity },
    });

    fetch(endpoint, { method, headers: headersWithStoreId, body })
      .then(response => {
        if (response.ok) {
          response.json().then(data => {
            // aggiungo il prodotto
            dispatch({
              type: ADD_TO_CART_SUCCESS,
              payload: {
                product: {
                  ...product,
                  freeCorrelatedProduct: data.product.freeCorrelatedProduct,
                  sellIfOutOfStock: data.product.sellIfOutOfStock,
                },
                quantity,
                image: data.product.image,
              },
            });
            setTimeout(() => {
              dispatch({
                type: CLOSE_ADDED_TO_CART,
              });
            }, 3000);

            // aggiorno il carrello
            if (!!data.carts) {
              dispatch({
                type: LOAD_SUCCESS,
                payload: {
                  products: data.carts,
                },
              });
            }
          });
        } else {
          dispatch({
            type: ADD_TO_CART_FAILURE,
            payload: response.statusText,
          });
        }
      })
      .catch(error => {
        dispatch({
          type: ADD_TO_CART_FAILURE,
          payload: error,
        });
      });
  };
}

// API CALL
export function updateCartQuantity(productId, quantity) {
  const cartId = localStorage.getItem('cartId');

  return {
    [RSAA]: {
      ...api.updateCartQuantity(cartId, productId, quantity),
      types: [
        UPDATE_CART_QUANTITY_REQUEST,
        UPDATE_CART_QUANTITY_SUCCESS,
        UPDATE_CART_QUANTITY_FAILURE,
      ],
    },
  };
}

// API CALL
export function removeFromCart(product) {
  const cartId = localStorage.getItem('cartId');

  return {
    [RSAA]: {
      ...api.removeProductFromCart(cartId, product.id),
      types: [
        REMOVE_FROM_CART_REQUEST,
        REMOVE_FROM_CART_SUCCESS,
        REMOVE_FROM_CART_FAILURE,
      ],
    },
  };
}

export function emptyCart() {
  localStorage.removeItem('cartId');
  return {
    type: EMPTY_CART,
  };
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = [];

const cleanProducts = cartProducts => {
  // gestisco i prodotti in omaggio
  // controllo ogni prodotto per vedere se è un omaggio
  let products = cartProducts;
  products = products.map(product => {
    if (!!product.quantityFree) {
      // se lo è controllo la quantità
      if (product.quantity > product.quantityFree) {
        // se la quantità è maggiore della quantità in omaggio
        return [
          {
            ...product,
            quantity: product.quantity - product.quantityFree,
          },
          {
            ...product,
            quantity: product.quantityFree,
            price: 0,
            isFreeCorrelatedProduct: true,
          },
        ];
      } else {
        return {
          ...product,
          price: 0,
          isFreeCorrelatedProduct: true,
        };
      }
    }
    return product;
  });
  // appiattisco
  return products.flat();
};

const changeCartQuantity = (cart, productId, quantity) => {
  return cart
    .map(cartItem => {
      if (cartItem.id === productId && !cartItem.isFreeCorrelatedProduct) {
        const anyFreeCorrelatedProduct = cart.find(
          product =>
            product.id === productId && !!product.isFreeCorrelatedProduct
        );
        return {
          ...cartItem,
          quantity: quantity + (anyFreeCorrelatedProduct ? -1 : 0),
        };
      }
      return cartItem;
    })
    .filter(product => product.quantity >= 1);
};

export default function cartReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_SUCCESS: {
      return cleanProducts(action.payload.products);
    }

    case ADD_TO_CART_SUCCESS: //action.payload.product.id
      // Check if product is already in the cart; it should never happen as the
      // Action creator calls the UPDATE if the product is already in the cart
      const existingProduct = state.find(
        product =>
          product.id === action.payload.product.id &&
          !product.isFreeCorrelatedProduct
      );

      if (existingProduct && !action.payload.product.isFreeCorrelatedProduct) {
        const anyFreeCorrelatedProduct = state.find(
          product =>
            product.id === action.payload.product.id &&
            !!product.isFreeCorrelatedProduct
        );
        return changeCartQuantity(
          state,
          existingProduct.id,
          existingProduct.quantity +
            action.payload.quantity +
            (anyFreeCorrelatedProduct ? 1 : 0)
        );
      }

      return [
        ...state,
        {
          ...action.payload.product,
          quantity: action.payload.quantity,
        },
      ];

    case UPDATE_CART_QUANTITY_SUCCESS: {
      return cleanProducts(action.payload.carts);
    }

    case REMOVE_FROM_CART_SUCCESS:
      return cleanProducts(action.payload.carts);

    case EMPTY_CART:
      return [];

    case CREATE_ORDER_NOT_AVAILABLE:
      // Per LaFarmaceutica
      return action.payload.map(product => {
        // Il carrello diventa il risultato
        // della check availability,
        // riportando la availability sulla quantity
        // in modo da settare il carrello con
        // le quantità disponibili
        const cartProduct = {
          ...product,
          quantity: product.availableQuantity,
          availableLessThanRequested:
            product.availableQuantity < product.quantity,
        };
        delete cartProduct.availableQuantity;
        return cartProduct;
      });

    default:
      return state;
  }
}

// ------------------------------------
// Selectors
// ------------------------------------

export function isInCart(globalState, productId) {
  const product = globalState.cart.find(product => product.id === productId);
  return !!product;
}

export function quantityInCart(globalState, productId) {
  const product = globalState.cart.find(product => product.id === productId);
  if (product) {
    return product.quantity;
  }
  return 0;
}

export function getMaxAddable(globalState, product) {
  let minAvailable = 200;
  const { sellProductsOutOfStock } = globalState.store.data.funzionalita;
  const quantityInCartNow = quantityInCart(globalState, product.id);

  if (sellProductsOutOfStock || !!product.sellIfOutOfStock) {
    // Se vendo fuori stock
    // conta solo maxNumInCart
    if (product.maxNumInCart) {
      minAvailable = product.maxNumInCart;
    }
  } else {
    // Altrimenti conta il minimo tra
    // maxNumInCart (se c'è) e lo stock
    if (product.maxNumInCart) {
      minAvailable = Math.min(product.stock, product.maxNumInCart);
    } else {
      minAvailable = product.stock;
    }
  }

  // Sottraggo alla quantità disponibile
  // il numero di prodotti che ho già nel carrello
  let maxAddable = minAvailable - quantityInCartNow;

  // Al massimo consento 99 pezzi disponibili per un utente
  if (maxAddable >= 100) {
    maxAddable = 99;
  }

  return maxAddable;
}

export function getCartTotal(globalState) {
  let cartTotal = globalState.cart.reduce((total, product) => {
    return total + product.price * product.quantity;
  }, 0);

  return cartTotal;
}

export function getCartTotalDiscountable(globalState) {
  const { couponIsAppliedToSopOtc } = globalState.store.data.funzionalita;
  let cartTotal = globalState.cart
    .filter(prod => {
      if (!couponIsAppliedToSopOtc) {
        return prod.type !== 'farmaci' && prod.taxCreditType !== 'DRUG';
      }
      return true;
    })
    .reduce((total, product) => {
      return total + product.price * product.quantity;
    }, 0);

  return cartTotal;
}

export function getCartTotalDiscountedCoupon(globalState) {
  let cartTotal = getCartTotal(globalState);

  let discount = globalState.checkout.coupon.discount;
  const minAmount = globalState.checkout.coupon.minAmount;

  if (!isValidCoupon(globalState)) {
    discount = 0;
  }

  if (!minAmount || cartTotal >= minAmount) {
    // Minimo non richiesto o raggiunto
    cartTotal = cartTotal - discount;
  }

  return cartTotal;
}

export function getDiscount(globalState) {
  let discountMessage = '';
  const discount = globalState.checkout.coupon.discount;
  const minAmount = globalState.checkout.coupon.minAmount;
  const cartTotal = getCartTotal(globalState);

  if (discount > 0) {
    if (!minAmount || cartTotal >= minAmount) {
      // Minimo non richiesto o raggiunto
      discountMessage = discount;
    } else {
      // Importo minimo non raggiunto
      discountMessage = 'Importo minimo € ' + minAmount.toFixed(2);
    }
  }

  return discountMessage;
}

export function getCartTotalWithExpenses(globalState) {
  let cartTotal = getCartTotalDiscountedCoupon(globalState);

  cartTotal = cartTotal + globalState.checkout.shippingCost;
  cartTotal = cartTotal + globalState.checkout.paymentCost;

  return cartTotal;
}

export function existsFreeShipping(globalState) {
  return !!globalState.store.data.costiSpedizione.freeShippingThreshold;
}

export function hasFreeShipping(globalState) {
  return (
    existsFreeShipping(globalState) &&
    getCartTotal(globalState) >=
      globalState.store.data.costiSpedizione.freeShippingThreshold
  );
}
